import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const PortalAuthContext = createContext(null);

export function PortalAuthProvider({ children }) {
  const [employee, setEmployee] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/portal/auth/me");
      setEmployee(data);
    } catch {
      setEmployee(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/portal/auth/login", { email, password });
    setEmployee(data.employee);
    return data.employee;
  };

  const logout = async () => {
    try {
      await api.post("/portal/auth/logout");
    } catch {
      /* ignore */
    }
    setEmployee(null);
  };

  return (
    <PortalAuthContext.Provider value={{ employee, loading, login, logout, refresh }}>
      {children}
    </PortalAuthContext.Provider>
  );
}

export function usePortalAuth() {
  const ctx = useContext(PortalAuthContext);
  if (!ctx) throw new Error("usePortalAuth must be used inside PortalAuthProvider");
  return ctx;
}
